import api from '@/utils/api';

export function login(form: any) {
  return api.post('/api/v1/login/', form);
}

export function logout() {
  return api.delete('/api/v1/logout/');
}

export function getUserCommonInfo() {
  return api.get('/accounts/get_common_site_info/');
}

export function getCsrf() {
  return api.get('/api/v1/csrf/');
}

export function register(form: any) {
  return api.post('/api/v1/accounts/register/', form);
}
